import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../redux/actions/login/loginAction';
import LoginForm from '../../components/login/loginForm';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  console.log('Rendering LoginPage');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const { loading, error, user } = useSelector((state) => state.login);

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(form));
  };

  return (
    <LoginForm
      username={form.username}
      password={form.password}
      onChange={handleChange}
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      user={user}
    />
  );
};

export default LoginPage; 